<template lang="pug">
span#genospinner(:class="loading && !loadtext ? 'spinning' : ''" style="width:100%;height: 100%;position:relative;display:block;") {{loading &&  loadtext ? loadtext : text}}
  span.spinwrapper(v-if="loading && !loadtext" :style="`position:absolute;left:50%;top:50%;width:${sz}px;height:${sz}px;margin-left:${-1 * sz/2}px;margin-top:${-1 * sz/2}px;`" ) 
    geno-logo.genospinner.rotateLoading
</template>
<script>  
import { px } from '@/utils/uiScale'
export default {  
    props: ['size', 'loading', 'text', 'loadtext'],
    data() {
    return {
    loadtext2: 'Running'
    }
    },
computed: {
    // size is a design-time px value; follow the UI scale (src/utils/uiScale.js)
    sz() { return px(Number(this.size) || 0) },
    },
}
</script> 
<style>
.genospinner {
height: inherit;
width: inherit;
}
#genospinner.spinning {
color: transparent !important;
}
.socialButton #genospinner.spinning svg circle {
fill: #f96332;
}
.socialButton #genospinner {
margin-top: -14px;
}
</style>

